import { Box, makeStyles } from "@material-ui/core";

import Tag from "./../Tag";

const useStyles = makeStyles(theme => ({
  tagList: {
    marginBottom: theme.spacing(3.125),
    justifyContent: "left",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: theme.spacing(-1.25),
    [theme.breakpoints.down("xs")]: {
      justifyContent: "center",
    },
    "& > *": {
      marginTop: theme.spacing(1.25),
      marginRight: theme.spacing(0.625),
    },
  },
}));

interface Props {
  tags: string[];
  isFeatured: boolean;
  isActiveOwner: boolean;
  isNft?: boolean;
  isNewListing?: boolean;
}

export default function TagList(props: Props) {
  const { tags, isFeatured, isNft, isActiveOwner, isNewListing } = props;

  const classes = useStyles();

  return (
    <Box data-testid="tag-list">
      <Box className={classes.tagList}>
        {isFeatured && (
          <Tag color="purple" filled>
            Featured Listing
          </Tag>
        )}
        {isNewListing && (
          <Tag color="green" filled>
            New
          </Tag>
        )}
        {isActiveOwner && (
          <Tag color="green" filled>
            Active Owner
          </Tag>
        )}
        {isNft && (
          <Tag color="purple" filled>
            NFT
          </Tag>
        )}
        {tags.map((tag, key) => (
          <Tag key={key}>{tag}</Tag>
        ))}
      </Box>
    </Box>
  );
}
